import { LogoutOutlined, BellOutlined } from '@ant-design/icons'
import { Avatar, Badge, Dropdown, Menu, Space } from 'antd'
import { useContext, FC, memo, useCallback, useState, useEffect } from 'react'
import type { MenuInfo } from 'rc-menu/lib/interface'
import globalContext from '~/contexts/global.context'
// import styles from './index.module.less'
import { useHistory } from 'react-router-dom'
import { routeNames } from '~/routes/const'
import { IUserInfoProps } from './const'
import avatar from '~/assets/images/default_avatar.png'
import instance from '~/request/instance'

const Component: FC<IUserInfoProps> = (props) => {
  const { name, count, dispatch, dispatchAction } = useContext(globalContext)

  const history = useHistory()
  useEffect(() => {
    dispatchAction('getBageCount')
  }, [])

  // setInterval(() => {
  //   dispatchAction('getBageCount')
  // }, 1000 * 60 * 10)
  const onMenuClick = useCallback(
    (event: MenuInfo) => {
      const { key } = event
      if (key === 'logout') {
        window.localStorage.removeItem('Authorization')
        dispatch({ name: '' })
        history.replace(routeNames.login)
        return
      }
    },
    [history]
  )

  const menuHeaderDropdown = (
    <Menu selectedKeys={[]} onClick={onMenuClick}>
      <Menu.Item key="logout">
        <LogoutOutlined />
        退出登录
      </Menu.Item>
    </Menu>
  )

  return (
    <Dropdown overlay={menuHeaderDropdown}>
      <Space>
        <Badge count={count} size='small' offset={[0, 32]}>
          <BellOutlined style={{ fontSize: 28, display: 'inline-block', marginTop: 28 }} onClick={() => history.push('/messageList')} />
        </Badge>
        <Avatar src={avatar} />
        <span>{name}, 您好</span>
      </Space>
    </Dropdown>
  )
}

Component.defaultProps = {}
Component.displayName = 'UserInfo'

const UserInfo = memo(Component)
export default UserInfo
